export default __webpack_public_path__ + "static/media/pic20.74b9696a.jpg";